import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { appNavStyles } from './app-nav.css';
import { renderAppNavPresentation, type AppNavProps } from './app-nav-presentation';

@customElement('app-nav')
export class AppNav extends LitElement {
  static styles = [appNavStyles];

  @property({ type: String }) currentTab = 'about';

  private selectTab(tab: string) {
    this.dispatchEvent(
      new CustomEvent('nav-change', {
        detail: { tab },
        bubbles: true,
        composed: true,
      })
    );
  }

  render() {
    const props: AppNavProps = {
      currentTab: this.currentTab,
      onSelectTab: (tab: string) => this.selectTab(tab),
    };

    return renderAppNavPresentation(props);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'app-nav': AppNav;
  }
}
